<template>
  <main id="app" class="px-1 pb-3" >

    <div class="row d-flex justify-content-center p-0 m-0">

      <div class="back-transparent w-100 d-flex mb-2 justify-content-center" >  
        <span class="d-flex w-100 justify-content-between px-1 cardDash"> 
          <span>Vou Passar 
            <span class="medium mx-1">@simulados</span> 
          </span>  
          <span @click="logoff()" class="medium pt-2 pointer">Sair</span>  
        </span>  
      </div> 
    
      <b-card v-if="!menuSelected" class="cardDash px-0" > 
        
        <h5 class="text-center pb-2"> Backoffice</h5> 
 
        <div class="d-flex flex-row">
 
          <b-card-text class="m-0 p-0">
            <h6>Chat</h6>
            <b-button  @click="menuSelected = 'chat'" variant="outline-info">Entrar </b-button>
          </b-card-text> 
        </div>
        
        <hr/>
        
        <div class="row m-0 p-0"> 
          <h6 class="p-0">Pagamentos</h6>
          <b-card-text class="m-0 p-0 ">
            <b-button  @click="menuSelected = 'pagamentos'" variant="outline-info">Entrar</b-button> 
          </b-card-text> 
        </div> 
  
        <hr/>

        <div class="row m-0 p-0"> 
          <h6 class="p-0">Aleteração de valores</h6>
          <b-card-text class="m-0 p-0 ">
            <b-button  @click="menuSelected = 'valores'" variant="outline-info">Entrar</b-button> 
          </b-card-text> 
        </div> 
        <hr/>

        <div class="row m-0 p-0"> 
          <h6 class="p-0">Ativação de usuários</h6>
          <b-card-text class="m-0 p-0 ">
            <b-button  @click="menuSelected = 'usuarios'" variant="outline-info">Entrar</b-button> 
          </b-card-text> 
        </div> 
   
      </b-card>
  
    </div>
     
    <Chat v-if="menuSelected == 'chat'" @toDash="toDash"/>

    <Pagamentos v-if="menuSelected == 'pagamentos'" @toDash="toDash"/>
    <Valores v-if="menuSelected == 'valores'" @toDash="toDash"/>
    <Usuarios v-if="menuSelected == 'usuarios'" @toDash="toDash"/>
 
    <b-modal id="modal-login" 
      @show="$bvModal.hide('modal-register')"
      hide-footer  
      hide-header
      no-close-on-esc
      no-close-on-backdrop > 
      <b-alert
        class="alertWarning"
        :show="dismissCountDown" 
        variant="warning"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged">
        <p>Usuário ou senha inválidos...</p>
        <b-progress
          variant="warning"
          :max="dismissSecs"
          :value="dismissCountDown"
          height="2px">
        </b-progress>
      </b-alert>  

      <div class="wrapper mt-1">
        <div class="logo">
            <img src="./assets/logo.png" alt="">
        </div>

        
        <div class="text-center mt-4 form">
            Login
        </div>

        <div class="p-3 mt-3">

          <div style="position: relative">
            <div class="form-field d-flex align-items-center my-3"> 
              <input type="text"  v-model="email" maxlength="100" placeholder="Email">
            </div>
            <label class="text-danger">{{msgEmail}}</label>
          </div>

          
          <div style="position: relative" class="pt-3">
            <div class="form-field d-flex align-items-center"> 
              <input type="password" v-model="password" maxlength="12" placeholder="Password">
            </div>
            <label class="text-danger">{{ msgPassword }}</label>
          </div>

          <button @click="login()" class="btn mt-3">
            <SpinnerLoad v-if="loadingBtn" /> 
            <label v-else>
              Login
            </label>
          </button>
        </div> 
      </div>
 
    </b-modal>
 
  </main>
</template>

<script> 
 
import Chat from './components/Chat.vue' 
import Pagamentos from './components/Pagamentos.vue' 
import Valores from './components/Valores.vue' 
import Usuarios from './components/Usuarios.vue' 
import axios from "axios";
 
export default {
  name: 'App',
  components: {  
    Pagamentos, 
    Chat,
    Valores,
    Usuarios 
  },
  data() {
    return {
     
      createdUser: false,
      loadingBtn: false,
      loadingPayment: false,
      loadingPaymentEbook: false,
    
      selected: [], // Must be an array reference!
      options: [],
      
      userName: '',
      
      menuSelected: 'chat',
      
      msgEmail: '',
      msgPassword: '',
      email: '',
      password: '',
      

      dismissSecs: 10,
      dismissCountDown: 0,

      showDismissibleAlert: false,
      token: '',
      provaSelected: '',

    };
  },
 
  mounted(){
  
    if (localStorage.getItem('backoffice-token')) {
      try {
        this.token = localStorage.getItem('backoffice-token');   
      } catch(e) {
        this.$bvModal.show('modal-login');
        localStorage.removeItem('backoffice-token');
      }
    } else {
      this.$bvModal.show('modal-login');
      localStorage.removeItem('backoffice-token');
    }
    
  
  },
  methods: {
 
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
 
 
    toDash() {
      this.menuSelected = false;
    },
   
 
    logoff() {
      this.$bvModal.hide('modal-menu');
      this.$bvModal.show('modal-login');
      localStorage.removeItem('backoffice-token');
    },
    login() { 
      var self = this;  

       this.msgEmail = ''   
       this.msgPassword = '';

      if(!this.email){
        this.msgEmail = "Informe o email?";
        return
      }
 
      if(!this.password){
        this.msgPassword = "Informe o password?"
        return
      }

      this.loadingBtn = true;
      
      axios.post(process.env.VUE_APP_APIURL+`auth/login`,{
        email: self.email.trim(),
        password: self.password
      })
      .then(async (response) => {
        console.log("🚀 ~ .then ~ response.data:", response.data)
        if(response.data.type == 'adm'){
          self.$bvModal.hide('modal-login')
          self.loadingBtn = false;
          localStorage.setItem('backoffice-token', response.data.access_token); 
        } else {
          self.dismissCountDown = self.dismissSecs
          self.loadingBtn = false;
        }
      })
      .catch(async () => {
        self.dismissCountDown = self.dismissSecs
        self.loadingBtn = false;
      });
    },
 
  }

}
</script>

<style lang="scss">

#modal-login {
  .modal-content{
    -webkit-box-shadow: none; // retira a sombra
    box-shadow: none; // retira a sombra 
    border: none !important; //  retira a borda
  }
} 

#modal-register {
  .modal-content{
    -webkit-box-shadow: none; // retira a sombra
    box-shadow: none; // retira a sombra 
    border: none !important; //  retira a borda
  }
}

 
#modal-register ~ .modal-backdrop {
  background-color: #ffffff !important;
  opacity: 1 !important;
}
#modal-login ~ .modal-backdrop {
  background-color: #ffffff !important;
  opacity: 1 !important;
}

html{
  background-color: #0194ef;
}

#btn-value {
  input {
    display: none;
  }
}
.red {
  background-color: red;
}

.textALinkBr{
  font-size: 86%;
  color: #000dff;
}
 
button { 
  font-size: 87% !important;
}
#modal-register {  
    .modal-dialog { 
      height: 100% !important;
    }
 
    .wrapper { 
      position: relative !important; 
      top: 10% !important;
    }
  }
#modal-login {
    .modal-dialog { 
      height: 100% !important;
    } 
 
    .wrapper { 
      position: relative !important; 
      top: 10% !important;
    }
  }
 
.promotion-item__description {
    padding-top: 5px;
    text-align: left;
}

.numberLbl{
  font-size: 13px !important;
  background-color: #009dff80;
  color: #ffffff !important; 
  font-weight: 600;
  width: 25px !important;
  height: 25px !important;
  margin-left: 8px;
  margin-right: 8px;
}

.nameLbl{
  font-size: 15px;
  font-weight: 500; 
  color: #175a8a !important; 
}

.pointsLbl{
  font-size: 11px;
  font-weight: 600; 
  color: #175a8a !important; 
}

.disable{
  border: 3px solid #7d98ac66 ;
  border-radius: 5px;
  margin-top: 8px !important;
}

.cardDash {
  max-width: 500px !important; 
}
.lblTime {
  font-size: 12px;
  font-weight: 600;
  margin: 0 0 15px 5px !important;
  color: #175a8a !important; 
}

a {  
  text-decoration: none !important; 
  font-size: 14px;
  font-weight: 400;
  color: #175a8a !important;
  margin-top: 13px !important;
}

.btnStart {  
  background-color: #00FA9A !important;
  color: #000302 !important;
  font-weight: bold !important;
  border: none !important;
  opacity: 0.8 !important;  
}
.btnSize {
  max-width: 120px !important; 
}
 
.text-danger {
  font-size: 11px;
  position: absolute;
  bottom: -16px !important;
  margin-left: 4px;
}

.input-group-text {
  background-color: transparent !important;
  border: none !important; 
}
 
.custom-checkbox.b-custom-control-lg, .input-group-lg .custom-checkbox { 
    padding-left: 0 !important;
    font-size: 1.1rem !important;
}

.custom-control-label {
  position: absolute;
  margin-top: -2px;
}
  
.rb-Crite {
  .bv-no-focus-ring {
    flex-direction: column;
    max-height: 130px;
    display: flex; 
    flex-wrap: wrap;
  }
  span{
    font-size: .85rem !important;
  }
}

/*Custom checkboxes style*/ 
input[type="checkbox"] {
  width: 30px;
  height: 20px;
  box-sizing: border-box;
  padding: 0; 
}
input[type="checkbox"]:checked {
  animation: effect 250ms ease-in !important;
  width: 30px;
  height: 20px;
}

@keyframes effect {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(1.3);
  }
  75% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
 

.img-fluid {
    max-width: 580px !important;
}
.pointer {
  cursor: pointer;
}
  
.back-transparent{
  background-color: #009dff7a !important;
  color: white;
  span {
    font-size: 26px;
    color: '#f7efef';
    font-family: 'serif'; 
    font-weight: 800;
    text-shadow: #000000 2px 2px 10px;
    .medium {
      font-size: 18px;
    }
    .menu {
      font-family: 'Helvetica'; 
      font-weight: bold;
      font-size: 30px; 
      text-align: end;
    }
  }
}
 
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  color: #2c3e50; 
  background-color: #009CFF;
  display: flex;
  flex-direction: column;
  height: 100vh;
   
}
main {
  background-image:
    linear-gradient(to bottom, #009CFF, rgba(117, 19, 93, 0.078)),
    url('./assets/background.jpg'); 
    height: 100vh !important;
  }

 /* Importing fonts from Google */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');

 
.alertWarning {
    max-width: 350px; 
    margin: auto;  
    border-radius: 15px;  
}

.wrapper {
    padding-top: 17px !important;
    max-width: 360px;
    min-height: 510px;
    margin: auto; 
    background-color: #ecf0f3;
    border-radius: 15px;
    box-shadow: 3px 3px 3px #cbced1, 3px 3px 20px #fff;
    a {
      color: #03A9F4 !important;
      font-size: 15px !important;
    }
    .btn:hover {
      color: white !important; 
    }
}

.logo {
    width: 70px;
    margin: auto;
}

.logo img {
    width: 100%;
    height: 70px;
    object-fit: fill;
    border-radius: 50%;
    box-shadow: 0px 0px 3px #69ce0b,
        0px 0px 0px 5px #ecf0f3,
        8px 8px 15px #76f076b5,
        -8px -8px 15px #fff;
}

.wrapper .form {
    font-weight: 600;
    font-size: 1.1rem;
    letter-spacing: 1.2px;
    padding-left: 8px;
    color: #555;
}

.wrapper .form-field input {
    width: 100%;
    display: block;
    border: none;
    outline: none;
    background: none;
    font-size: 1.0rem;
    color: #666;
    padding: 8px 13px 8px 8px;
    /* border: 1px solid red; */
}

.wrapper .form-field {
    padding-left: 8px;
    margin-bottom: 20px;
    border-radius: 10px;
    box-shadow: inset 5px 5px 5px #cbced192, inset -3px -3px 3px #fff;
}

.wrapper .form-field .fas {
    color: #555;
}

.wrapper .btn {
    box-shadow: none;
    width: 100%;
    height: 40px;
    background-color: #03A9F4;
    color: #fff;
    border-radius: 25px; 
    letter-spacing: 1.3px;
}

.wrapper .btn:hover {
    background-color: #039BE5;
}
.wrapper .btn:disabled {
    background-color: #039BE5;
    border: none;
}

.wrapper a {
    text-decoration: none;
    font-size: 0.8rem;
    color: #03A9F4;
}

.wrapper a:hover {
    color: #039BE5;
}

.progress-bar-striped {
  background-color: #03A9F4 !important; 
}

@media(max-width: 380px) {
  .wrapper { 
    padding: 30px 15px 15px 15px;
  }
}  

.input-none {
  width: 10px;
  height: 10px;
  z-index: -1;
  position: absolute;
  color: transparent !important;
  border: none;
}

 
</style>
